import { apiInstance } from '@diamond/shared/utils';
import { ProductRewardsResponse } from '@diamond/sol-buyer/utils';

const PRODUCT_REWARDS_PATH = '/backoffice/order';

/**
 * Fetch product rewards (promo + voucher) for an order.
 */
export const getProductRewards = async (
  orderId: string,
  token: string
): Promise<ProductRewardsResponse> => {
  if (!orderId) {
    throw new Error('orderId is required');
  }

  const response = await apiInstance(token).get<ProductRewardsResponse>(
    `${PRODUCT_REWARDS_PATH}/${orderId}/product-rewards`
  );
  return response.data;
};
